import { memoizedGet } from "@chakra-ui/utils";
import { ThemeTypings } from "@/ui";

export default function getColorToken(theme: object, token: ThemeTypings["colors"]) {
  const hex = memoizedGet(theme, "semanticTokens.colors." + token);
  return hex;
}
